var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthyLifeHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17563 19.7423C5.57992 17.2156 8.37621 16.6681 9.72382 16.7102C12.3769 18.9001 16.874 23.0186 20.0072 25.4443C23.9237 28.4764 34.5361 35.046 38.579 35.2987C42.6218 35.5513 42.6218 33.1509 43.3798 35.6777C44.1379 38.2044 39.9176 40.0721 34.8475 39.0143C27.3217 37.4441 24.3894 34.7136 14.6148 29.4355C6.65646 25.1382 4.67028 22.9008 5.17563 19.7423Z",
    fill: "url(#paint0_linear_6598_9532)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49805 17.1063C8.03579 11.9093 12.0462 9.82078 14.3203 9.14697C15.331 8.8475 15.9627 12.5581 19.7529 14.4532C22.8558 16.0046 27.0805 15.3376 27.9649 15.3376C29.6073 15.3376 31.755 28.2241 37.0613 30.8772C44.2626 34.4778 46.5366 36.1834 37.0613 36.0571C27.5859 35.9307 22.6308 31.5734 17.4494 26.0145C12.7764 21.8453 7.49807 22.3954 7.49805 17.1063Z",
    fill: "#FDA9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0842 26.2328C33.0842 26.2328 32.1515 27.5516 30.3095 27.9482",
    stroke: "#002C50",
    strokeWidth: 1.56388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9842 20.5601C29.9842 20.5601 28.6041 21.3129 27.6004 21.4748",
    stroke: "#002C50",
    strokeWidth: 1.56388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3028 23.578C31.3028 23.578 30.6646 24.3463 28.6366 24.8041",
    stroke: "#002C50",
    strokeWidth: 1.56388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6598_9532",
    x1: 24.2596,
    y1: 31.7813,
    x2: 17.8086,
    y2: 40.8714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthyLifeHeart);
export default __webpack_public_path__ + "static/media/HealthyLifeHeart.720f8e695fb171dfb0cc323528267de8.svg";
export { ForwardRef as ReactComponent };